import { ScreenName } from '@helpcenter/constants';
import type { Route } from 'react-resource-router';
import { getFlexiHelpCenterRoute } from '../advanced-help-center';

export const getHelpCenterRoute = (): Route => {
    const name = 'help-center';
    const path = '/portals';
    const screenName = ScreenName.HELP_CENTER;

    return getFlexiHelpCenterRoute(name, path, screenName);
};
